import {
  EVENT_KEY_ENTER,
  EVENT_KEY_SPACE_BAR,
} from '../../../../constants/event'

export const INTERACTIVE_KEYS = new Set([EVENT_KEY_ENTER, EVENT_KEY_SPACE_BAR])
